import React, { useState } from "react";
import { JdsButton } from "../../../components/jds/JdsButton";
import { ClienteModal, AlertIcon } from "./clienteUi";

export default function CancellationModal({ title, setOpen, onConfirm, defaultId, reasonMaxLength }) {
  const [isLoading, setIsLoading] = useState(false);
  const [id] = useState(defaultId || "");
  const [cancellationReason, setCancellationReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!cancellationReason.trim()) {
      setError("O motivo é obrigatório.");
      return;
    }
    setError("");
    setIsLoading(true);
    try {
      await onConfirm({ id, cancellationReason });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDismiss = () => {
    setOpen(false);
  };

  return (
    <ClienteModal
      icon={<AlertIcon />}
      title={`Cancelar ${title}`}
      description="Esta ação é irreversível. Preencha o motivo para prosseguir com o cancelamento."
      actions={
        <>
          <JdsButton
            variant="outlined"
            color="neutral"
            onClick={handleDismiss}
            disabled={isLoading}
          >
            Voltar
          </JdsButton>
          <JdsButton color="error" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? "Processando..." : "Confirmar cancelamento"}
          </JdsButton>
        </>
      }
    >
      <div className="form-group mb-0">
        <label htmlFor="cancellation-reason">
          Motivo do cancelamento <span className="text-danger">*</span>
        </label>
        <textarea
          id="cancellation-reason"
          className={`form-control${error ? " is-invalid" : ""}`}
          placeholder="Descreva o motivo do cancelamento..."
          value={cancellationReason}
          onChange={e => setCancellationReason(e.target.value)}
          maxLength={reasonMaxLength}
          rows={4}
          disabled={isLoading}
        />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>
    </ClienteModal>
  );
}
